module.exports = __webpack_public_path__ + "static/media/KFOlCnqEu92Fr1MmWUlfCxc4AMP6lbBP.003e16ef.woff2";